import { gsap } from 'gsap';
import { debounce } from 'lodash';

import drawFittedImage from './draw-fitted-image';

class ScrollSequence {
  constructor(
    wrapper,
    frameCount,
    cover = false,
    pin = false,
    start,
    end = 'bottom top',
    markers = false,
  ) {
    this.wrapper = wrapper;
    this.canvasWrapper = wrapper.querySelector('.canvas-wrapper');

    this.canvas = wrapper.querySelector('.canvas');
    this.canvasContext = this.canvas.getContext('2d');

    this.frameCount = frameCount;
    this.frames = [];
    this.animation = { frame: 0 };
    this.currentFrame = null;

    this.cover = cover;
    this.pin = pin;

    if (!start) {
      this.start = pin ? 'top top' : 'top bottom';
    } else {
      this.start = start;
    }

    this.end = end;

    this.markers = markers;

    this.sequencePath = wrapper.dataset.sequencePath;

    this.setCanvasDimensions();
  }

  init() {
    this.preloadImages();
    this.frames[0].onload = () => { this.getCurrentFrame(); };

    gsap.to(this.animation, {
      frame: this.frameCount - 1,
      snap: 'frame',
      scrollTrigger: {
        trigger: this.wrapper,
        scrub: 0.2,
        pin: this.pin ? this.canvasWrapper || this.canvas : false,
        start: this.start,
        end: this.end,
        markers: this.markers,
      },
      onUpdate: () => {
        this.getCurrentFrame();
      },
    });

    window.addEventListener('resize', debounce(() => {
      this.setCanvasDimensions();
      this.render(this.currentFrame);
    }, 50));
  }

  setCanvasDimensions() {
    const wrapperRect = this.wrapper.getBoundingClientRect();
    this.canvas.width = wrapperRect.width;
    this.canvas.height = wrapperRect.height;
  }

  preloadImages() {
    for (let index = 0; index < this.frameCount; index += 1) {
      const frame = new Image();
      const path = window.innerWidth >= 768 ? this.sequencePath : `${this.sequencePath}_s`;
      frame.src = `${path}/${index}.jpg`;
      this.frames.push(frame);
    }
  }

  render(frame) {
    if (!frame) return;

    this.canvasContext.clearRect(
      0,
      0,
      this.canvas.width,
      this.canvas.height,
    );

    if (this.cover) {
      drawFittedImage(this.canvasContext, frame, 0, 0, this.canvas.width, this.canvas.height);
    } else {
      this.canvasContext.drawImage(
        frame, 0, 0, frame.width, frame.height, 0, 0, this.canvas.width, this.canvas.height,
      );
    }
  }

  getCurrentFrame() {
    const frame = this.frames[this.animation.frame];

    if (!frame) return;

    this.currentFrame = frame;
    this.render(frame);
  }
}

export default ScrollSequence;
